import { GetAllRequestResponse, StoreData } from "../../types";
import { getRequestWrapper } from "../../utilities";

export type getStoresResponse = GetAllRequestResponse<never, StoreData>;

export function getStores(): Promise<getStoresResponse> {
  return getRequestWrapper<never, getStoresResponse>({
    url: `${ENV_SETTINGS.API_URL}/stores`,
  });
}
